import { CONFIG } from "@/config";
import React from "react";
import { useIntl } from "react-intl";
import styles from "./LogoHeader.module.scss";
import classNames from "classnames";
import { useAtomValue } from "jotai/utils";
import { FooterVisible, SoundtrackEnabled } from "@/atoms";
export var LogoHeader = function () {
    var _a;
    var intl = useIntl();
    var soundtrackEnabled = useAtomValue(SoundtrackEnabled);
    var footerVisible = useAtomValue(FooterVisible);
    return (React.createElement("div", { className: classNames(styles.logoHeader, (_a = {},
            _a[styles.centered] = !soundtrackEnabled,
            _a[styles.hidden] = !footerVisible,
            _a)) },
        React.createElement("img", { src: CONFIG.logoUrl, "aria-label": intl.formatMessage({
                defaultMessage: "Skull and Bones",
                id: "wsbOf5",
            }) })));
};
